import React from 'react';
import { Flex, Grid, GridItem, Skeleton } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';

export const ContributionFormLoader: React.FC<{ full?: boolean }> = ({
  full = false,
}) => (
  <ContentContainer type={ContentContainerType.FORM} pt={12}>
    <Grid
      gap={4}
      w="full"
      gridTemplateColumns="repeat(3, 1fr)"
      gridTemplateRows="repeat(10, max-content)"
    >
      <GridItem pb={4}>
        <Skeleton height="70px" w="full" />
      </GridItem>
      <GridItem />
      <GridItem>
        <Flex justifyContent="flex-end">
          <Skeleton height="48px" w={24} />
          <Skeleton height="48px" w={24} ml={4} />
        </Flex>
      </GridItem>
      <GridItem>
        <Skeleton height="80px" w="full" />
      </GridItem>
      <GridItem>
        <Skeleton height="80px" w="full" />
      </GridItem>
      <GridItem>
        <Skeleton height="80px" w="full" />
      </GridItem>
      <GridItem>
        <Skeleton height="80px" w="full" />
      </GridItem>
      <GridItem>
        <Skeleton height="80px" w="full" />
      </GridItem>
      <GridItem />
      {full && (
        <>
          <GridItem gridColumn="1 / 3" pt={4}>
            <Skeleton height="14px" w="35px" />
          </GridItem>
          <GridItem />
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem gridColumn="1 / 3" pt={4}>
            <Skeleton height="14px" w="35px" />
          </GridItem>
          <GridItem />
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem />
          <GridItem />
          <GridItem gridColumn="1 / 3" pt={4}>
            <Skeleton height="14px" w="60px" />
          </GridItem>
          <GridItem />
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
          <GridItem>
            <Skeleton height="48px" w="full" />
          </GridItem>
        </>
      )}
    </Grid>
  </ContentContainer>
);
